import { useEffect, useState } from "react";
import { ApsContainer, ApsTypeGroup } from "UserExperience/portal-vnext";
import UploadCategory from "./UploadCategory";
import { useUploadCategoryList } from "./uploadCategoryListService";

const UploadCategoryList = ({chooseCategoryTitle, chooseCategoryText, categorySelected}) => {

  const { getCategories } = useUploadCategoryList();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let isUnloading = false;
    const fetchCategories = async () => {
      const fetchedCategories = await getCategories();
      if (!isUnloading) {
        setCategories(fetchedCategories);
      }
    };

    fetchCategories();

    return () => {
      isUnloading = true;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ApsContainer
      containerType="content"
      role="main"
    >
      <ApsTypeGroup
        className="breakpoint--tablet--is-hidden"
        groupType="title"
        groupAlign="center"
        groupTitle={chooseCategoryTitle}
        groupCopy={chooseCategoryText}
      />

      {categories && categories.map((category) =>
        <UploadCategory
          key={category.nameTextId}
          category={category}
          categorySelected={categorySelected}
        />
      )}
    </ApsContainer>
  );
};

export default UploadCategoryList;